import { IWidgetRequest } from '../widget-requests.interface';

export interface IWidgetRequestsAddEditDialogData {
  dialogTitle: string;
  submitButtonText: string;
  editData?: IWidgetRequest;
}

export enum ERestrictAccessBy {
  none = 'none',
  workspace = 'workspace',
  dashboard = 'dashboard',
}

export enum EWidgetRequestResultType {
  singleField = 'singleField',
  multipleFields = 'multipleFields',
  multipleValues = 'multipleValues',
}
